import getCredentialsUseCase from '@/domain/useCases/getCredentialsUseCase';

export const getCredentialsOrThrow = () => {
  const {accessToken} = getCredentialsUseCase();
  if(!accessToken) throw new Error('No access token');
  return accessToken;
};